import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M10 2v2.343", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 2v6.343", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8.5 2h7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 16h9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "2", x2: "22", y1: "2", y2: "22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlaskConicalOff";
const FlaskConicalOff = memo(themed(Icon));
export {
  FlaskConicalOff
};
//# sourceMappingURL=flask-conical-off.js.map
